import { Form, Input, Modal, Select } from "antd";
import { useEffect } from "react";
import { requestProvision } from "../../../request";
import { useForm } from "antd/lib/form/Form";
import ReactInputMask from "react-input-mask";

export const ModalInsertEdit = ({ visible, onCancel, id }) => {
  const [form] = useForm();

  useEffect(() => {
    if (id !== null) {
      getProvisionId();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const options = [
    { value: "A", label: "Ativo" },
    { value: "I", label: "Inativo" },
  ];

  const postProvision = async (data) => {
    const response = await requestProvision.postProvision(data, id);
    if (response.status === 201) {
      onCancel();
      form.resetFields();
    }
    if (response.status === 200) {
      onCancel();
      form.resetFields();
    }
  };

  const handleOk = () =>
    form
      .validateFields()
      .then((values) => postProvision(values))
      .catch((info) => {
        console.error("erro:", info);
      });

  const getProvisionId = async () => {
    const response = await requestProvision.getProvisionsId(id);
    if (response.status === 200) {
      const { data } = response;

      form.setFieldsValue({
        id: data.id,
        descricao: data.descricao,
        situacao: data.situacao,
        responsavel: data.responsavel,
        email: data.email,
        telefone: data.telefone,
      });
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={handleOk}
      destroyOnClose
    >
      <Form layout="vertical" form={form} preserve={false}>
        <Form.Item
          name="descricao"
          label="Empresa:"
          rules={[
            { required: true, message: "Este campo não pode ser em branco." },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="responsavel" label="Responsável:">
          <Input />
        </Form.Item>

        <Form.Item
          name="email"
          label="E-mail:"
          rules={[{ type: "email", message: "Digite um e-mail válido." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="telefone"
          label="Telefone:"
          rules={[
            {
              pattern: /^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/,
              message:
                "Digite um número de telefone válido. Ex: (11) 91234-5678",
            },
          ]}
        >
          <ReactInputMask mask={"(99) 99999-9999"}>
            {(inputProps) => (
              <Input {...inputProps} placeholder="(00) 00000-0000" />
            )}
          </ReactInputMask>
        </Form.Item>

        <Form.Item
          name="situacao"
          label="Situação:"
          style={{ width: 240 }}
          rules={[
            { required: true, message: "Este campo não pode ser em branco." },
          ]}
        >
          <Select options={options} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
